import axios, { AxiosInstance } from 'axios'

import { auth } from '../firebase'
import { getToken, setToken } from './utils/AuthManager'

// Hostinger CDN returns 404 for /api/<route> unless a physical file exists.
// Route through index.php so preflight (OPTIONS) and XHR reach PHP.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  'https://cornflowerblue-skunk-388583.hostingersite.com/api/index.php'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async config => {
    let token = getToken()
    if (auth.currentUser) {
      try {
        token = await auth.currentUser.getIdToken()
        setToken(token)
      } catch {
        // Fall back to the last stored token.
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      config.headers.setContentType(false)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Do not clear storage or hard-redirect here — that caused /auth ↔ /account loops
    // when a single API call returned 401 while the Firebase session was still valid.
    if (error.response?.data) {
      return Promise.reject(error.response.data)
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
